<template>
  <div class="health-suite">
    <div class="nav-container">
      <div class="d-flex justify-center navigation-buttons">
        <div class="button-wrapper position-relative">
          <v-btn
            :class="{ 'active-tab': currentTab === 'calendar' }"
            class="curved-button me-2"
            :style="currentTab === 'calendar' ? activeButtonStyle : {}"
            @click="handleCalendarClick"
            elevation="0"
            height="40"
          >
            My Calendar
            <v-badge
              v-if="currentTab === 'calendar'"
              color="error"
              dot
              floating
              location="top end"
            ></v-badge>
          </v-btn>
        </div>
        
        <div class="button-wrapper position-relative">
          <v-btn
            :class="{ 'active-tab': currentTab === 'tracker' }"
            class="curved-button ms-2"
            :style="currentTab === 'tracker' ? activeButtonStyle : {}"
            @click="navigateTo('tracker')"
            elevation="0"
            height="40"
          >
            My Tracker
            <v-badge
              v-if="currentTab === 'tracker'"
              color="error"
              dot
              floating
              location="top end"
            ></v-badge>
          </v-btn>
        </div>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed, provide } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useSettingsStore } from '@/api/store/settings';

const router = useRouter();
const route = useRoute();
const settingsStore = useSettingsStore();
const currentTab = ref('calendar');

const activeButtonStyle = computed(() => ({
  background: `linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), ${settingsStore.settings.primaryColor}`,
  color: 'white'
}));

type RefreshFunction = () => void;
const refreshCalendar = ref<RefreshFunction>(() => { /* intentionally empty */ });
provide('refreshCalendar', refreshCalendar);

const handleCalendarClick = () => {
  if (currentTab.value === 'calendar') {
    refreshCalendar.value();
  } else {
    navigateTo('calendar');
  }
};

const navigateTo = (tab: string) => {
  currentTab.value = tab;
  router.push({ name: `health-suite-${tab}` });
};

onMounted(() => {
  // Set initial tab based on route
  const routeName = route.name as string;
  if (routeName.includes('tracker')) {
    currentTab.value = 'tracker';
  } else {
    currentTab.value = 'calendar';
  }
});
</script>

<style scoped>
.health-suite {
  background: #F5F5F5;
}

.nav-container {
  background: white;
  box-shadow: 0px 0.5px 15px rgba(0, 0, 0, 0.05);
  padding: 16px 0;
  height: 73.06px;
}

.navigation-buttons {
  position: relative;
  z-index: 1;
}

.curved-button {
  min-width: 121.39px;
  height: 40px !important;
  border-radius: 20px;
  text-transform: none;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: normal;
  transition: all 0.3s ease;
  background: white;
}

.button-wrapper {
  position: relative;
}

.v-badge--dot {
  margin-top: -2px;
  margin-right: -2px;
}

:deep(.v-btn__content) {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
}
</style> 